import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "cookie_choice";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  const [exiting, setExiting] = useState(false);
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    try {
      const choice = localStorage.getItem(STORAGE_KEY);
      if (!choice) {
        const t = setTimeout(() => setShow(true), 800);
        return () => clearTimeout(t);
      }
    } catch (_) { /* storage blocked */ }
  }, []);

  const dismiss = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (_) {}
    setExiting(true);
    setTimeout(() => setShow(false), 470);
  };

  const onAccept = () => {
    setFlipped(true);
    setTimeout(() => dismiss("accepted"), 700);
  };

  if (!show) return null;

  return (
    <div
      className={`fixed z-[60] right-4 left-4 sm:left-auto bottom-4 sm:bottom-6 sm:right-6 max-w-md ${exiting ? "cookie-exit" : "cookie-enter"}`}
      role="dialog"
      aria-live="polite"
      aria-label="Avviso cookie"
      data-testid="cookie-banner"
    >
      <div className="relative">
        <div className="absolute -inset-0.5 rounded-3xl bg-gradient-to-br from-drosun-red/30 via-transparent to-drosun-steel/40 blur-md" aria-hidden />
        <div
          className="relative rounded-3xl border border-white/10 bg-drosun-navy/85 text-white p-6 sm:p-7 shadow-2xl"
          style={{ backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)" }}
        >
          <button
            onClick={() => dismiss("necessary")}
            className="absolute top-3 right-3 p-2 rounded-full hover:bg-white/10 transition-colors"
            aria-label="Chiudi"
            data-testid="cookie-banner-close"
          >
            <X size={18} />
          </button>

          <div className="flex items-center gap-3 mb-3">
            <span className="inline-flex w-10 h-10 items-center justify-center rounded-full bg-drosun-red/20 text-drosun-red">
              <Cookie size={20} />
            </span>
            <h3 className="font-display uppercase text-xl tracking-wide">Cookie & privacy</h3>
          </div>

          <p className="text-[15px] leading-relaxed text-white/85">
            Usiamo cookie tecnici per il funzionamento del sito. Nessun tracker invasivo.{" "}
            <Link to="/cookie" className="underline underline-offset-4 hover:text-drosun-red" data-testid="cookie-banner-link">
              Scopri di più
            </Link>
          </p>

          <div className="mt-5 flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => dismiss("necessary")}
              className="flex-1 px-4 py-3 rounded-md border border-white/30 hover:border-white text-sm font-semibold uppercase tracking-wide transition-colors"
              data-testid="cookie-banner-necessary"
            >
              Solo necessari
            </button>

            <div className="flip-stage flex-1">
              <div className={`flip-card relative h-[46px] ${flipped ? "is-flipped" : ""}`}>
                <button
                  onClick={onAccept}
                  className="flip-face absolute inset-0 px-4 rounded-md bg-drosun-red hover:bg-drosun-redHover text-white text-sm font-semibold uppercase tracking-wide transition-colors"
                  data-testid="cookie-banner-accept"
                  disabled={flipped}
                >
                  Accetta tutto
                </button>
                <div className="flip-face flip-back rounded-md bg-emerald-500 text-white text-sm font-semibold uppercase tracking-wide flex items-center justify-center">
                  ✓ Confermato
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
